/**
 * Prefixes for entities that have a unique numbering within a tenant.
 * Used to distinguish APIs that contain a number in their URL (e.g. `/foo/bar/PREFIX-:number`) from
 * APIs that contain a globally unique identifier in their URL (e.g. `/foo/bar/:id`).
 */
export enum NumberPrefixEnum {
  /** Prefix for BRS tasks */
  BRS_TASK_PREFIX = 'BRS',
  /** Prefix for HD tasks */
  HD_TASK_PREFIX = 'HD',
  /** Prefix for passage tasks */
  PASSAGE_TASK_PREFIX = 'GP',
}
